import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SessionModel } from '../interface/session-model';
import { Router } from '@angular/router';
import { URLEnum } from '../url-enum';
import { EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppconfigService } from '../service/appconfig.service';


@Injectable({
  providedIn: 'root'
})
export class NewpasswordmanagementService {
  SessionList: SessionModel = new SessionModel();
  public SecretQuestions = new BehaviorSubject({});
  public userdetails = new BehaviorSubject({})
  constructor(private http: HttpClient, private router: Router, private configService: AppconfigService) { }

  authenticateTempLogin(token: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'tranGUID': this.configService.config.tranGUID,
        'appinstanceId': this.configService.config.appInstanceId.toString(),
        'apiKey': this.configService.config.apiKey
      })
    };

    return this.http.post<any>(this.configService.config.authenticateTempLogin, token, httpOptions)
      .pipe(catchError((error: any) => {
        //intercept the respons error and displace it to the console
        console.log(error);
        this.handleError(error);
        return (error);
      }) as any);

  }
  // public getTermsAndConditionWithoutAccep(): Observable<any> {
  //   const httpOptions = {
  //     headers: new HttpHeaders(
  //       {
  //         'Content-Type': this.configService.config.Content_Type,
  //         'appInstanceId': this.configService.config.appInstanceId.toString(),
  //         'apiKey': this.configService.config.apiKey.toString()
  //       })
  //   }
  //   return this.http.get(this.configService.config.get_terms_and_condition_without_accept + '?contextName=' + this.configService.config.context_name, httpOptions)
  //     .pipe(catchError((error: any) => {
  //       //intercept the respons error and displace it to the console
  //       console.log(error);
  //       this.handleError(error);
  //       return (error);
  //     }) as any);
  // }

  public GetSecretQuestionTenant(userSessionID: string, tenantID: string): Observable<any> {
    const headersoption = {
      headers: new HttpHeaders(
        {
          'Content-Type': this.configService.config.Content_Type,
          'apiKey': this.configService.config.apiKey.toString()
        })
    };
    // const options = new RequestOptions({ headers: headers });
    return this.http.get(this.configService.config.url_getSecretQuestion + tenantID + '/questions', headersoption)
      .pipe(catchError((error: any) => {
        //intercept the respons error and displace it to the console
        console.log(error);
        this.handleError(error);
        return (error);
      }) as any);
  }

  forgotOTPValidation(reqbody: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'appInstanceId': this.configService.config.appInstanceId.toString(),
        'apiKey': this.configService.config.apiKey.toString()
      })
    };

    return this.http.post<any>(this.configService.config.url_forgototpvalidation, reqbody, httpOptions)
      .pipe(catchError((error: any) => {
        //intercept the respons error and displace it to the console
        console.log(error);
        this.handleError(error);
        return (error);
      }) as any);
  }


  validateSecretQuestion(questDt: any): Observable<any> {
    const headersoption = {
      headers: new HttpHeaders(
        {
          'Content-Type': this.configService.config.Content_Type,
          'appInstanceId': this.configService.config.appInstanceId.toString(),
          'apiKey': this.configService.config.apiKey.toString(),

        })
    };
    return this.http.post<any>(this.configService.config.url_ValidateSecretAnswer, questDt, headersoption)
      .pipe(catchError((error: any) => {
        //intercept the respons error and displace it to the console
        console.log(error);
        this.handleError(error);
        return (error);
      }) as any);
  }



 OtpResetPassword_noUsrNm(passwordDetails:any): Observable<any> {
    const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'tranGUID': this.configService.config.tranGUID,
            'appinstanceId': this.configService.config.appInstanceId.toString(),
            'apiKey': this.configService.config.apiKey,
            
        })
    };
    
    return this.http.post<any>(this.configService.config.url_OtpResetPassword, passwordDetails, httpOptions)
        .pipe( catchError((error: any) => {
          //intercept the respons error and displace it to the console
          console.log(error);
          this.handleError(error);
          return (error);
      }) as any);
  }
  OTPResetPassword(passwordDetails:any): Observable<any> {
    const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'tranGUID': this.configService.config.tranGUID,
            'appinstanceId': this.configService.config.appInstanceId.toString(),
            'apiKey': this.configService.config.apiKey,
            
        })
    };
    return this.http.post<any>(this.configService.config.url_Otpresetpass, passwordDetails, httpOptions)
        .pipe( catchError((error: any) => {
          //intercept the respons error and displace it to the console
          console.log(error);
          this.handleError(error);
          return (error);
      }) as any);
  }
  OTPchangePassword(passwordDetails: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'apiKey': this.configService.config.apiKey
      })
    };
    return this.http.post<any>(this.configService.config.url_changePsd, passwordDetails, httpOptions)
      .pipe(catchError((error: any) => {
        //intercept the respons error and displace it to the console
        console.log(error);
        this.handleError(error);
        return (error);
      }) as any);
  }


  public ValidateUser(loginId: string, emailID: string)
    : Observable<any> {

    const httpheaders = {
      headers: new HttpHeaders(
        {
          'Content-Type': this.configService.config.Content_Type,
          'appInstanceId': this.configService.config.appInstanceId.toString(),
          'apiKey': this.configService.config.apiKey.toString()
        })
    }
    const body =
    {
      username: loginId,
      email: emailID,
      tenantName: this.SessionList.TenentName != undefined ? this.SessionList.TenentName : this.configService.config.defaultTenant,
//      tenantLinkId: this.configService.config.customerid,
    }
    return this.http.post<any>(this.configService.config.url_ValidateUser, body, httpheaders)
      .pipe(catchError((error: any) => {
        //intercept the respons error and displace it to the console
        console.log(error);
        this.handleError(error);
        return (error);
      }) as any);
  }


  createSecretQuestion(questionDetails: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<any>(this.configService.config.url_userService, questionDetails, httpOptions)
      .pipe(catchError((error: any) => {
        //intercept the respons error and displace it to the console
        console.log(error);
        this.handleError(error);
        return (error);
      }) as any);
  }
   userSignUp(body:any):Observable<any>{
    const httpOptions={
      headers:new HttpHeaders({
        "Content-Type":"application/json",
      })
    };
    return this.http.post(this.configService.config.userSignUp,body,httpOptions).pipe(catchError((error: any) => {
      //intercept the respons error and displace it to the console
      console.log(error);
      this.handleError(error);
      return (error);
    }) as any);
  }
  private handleError(handleError: any): Observable<any[]> {
    this.SessionList.errorCode = handleError.status;
    //this.router.navigate([URLEnum.module + URLEnum.errorscreenComponent]);
    this.router.navigateByUrl( URLEnum.errorscreenComponent);
    return EMPTY;
  }
}